import { http } from './config/config-receituario'

export default {
  consultarCnpj: (token, cnpj) => {
    return http.get('mobile/cnpj', {
      headers: {
        Authorization: token,
      },
      params: {
        cnpj,
      },
    })
  },
}
